@if (netzzuordnungen) {
  <div>
    <table
      mat-table [dataSource]="netzzuordnungen"
      class="netzzuordnung-table"
      matSort
      (matSortChange)="_sortChange($event)"
      [matSortDirection]="sortDirection"
      [matSortActive]="sortActive"
      >
      <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
      <tr mat-row *matRowDef="let netzzuordnung; columns: columnsToDisplay"
        data-qa="tnb-netzzuordnungen-row">
      </tr>
      <ng-container matColumnDef="netzbetreiber.stadtwerkeId">
        <th mat-header-cell *matHeaderCellDef mat-sort-header data-qa="header-stadtwerkeId">Netzbetreiber-ID</th>
        <td mat-cell *matCellDef="let netzzuordnung;" data-qa="stadtwerkeId">{{netzzuordnung.netzbetreiber.stadtwerkeId}}</td>
      </ng-container>
      <ng-container matColumnDef="netzbetreiber.name">
        <th mat-header-cell *matHeaderCellDef mat-sort-header data-qa="netzbetreiberName">Netzbetreiber-Name</th>
        <td mat-cell *matCellDef="let netzzuordnung;" data-qa="netzbetreiberName">{{netzzuordnung.netzbetreiber.name}}</td>
      </ng-container>
      <ng-container matColumnDef="netzbetreiber.teilgebiet">
        <th mat-header-cell *matHeaderCellDef mat-sort-header data-qa="netzbetreiberTeilgebiet">Teilgebiete</th>
        <td mat-cell *matCellDef="let netzzuordnung;" data-qa="netzbetreiberTeilgebiet">{{netzzuordnung.netzbetreiber.teilgebiet}}</td>
      </ng-container>
      <ng-container matColumnDef="netzgruppe">
        <th mat-header-cell *matHeaderCellDef mat-sort-header data-qa="netzgruppe">Netzgruppe</th>
        <td mat-cell *matCellDef="let netzzuordnung;" data-qa="netzgruppe">{{netzzuordnung.netzgruppe}}</td>
      </ng-container>
      <ng-container matColumnDef="ortsname">
        <th mat-header-cell *matHeaderCellDef mat-sort-header data-qa="ortsname">Ortsname</th>
        <td mat-cell *matCellDef="let netzzuordnung;" data-qa="ortsname">{{netzzuordnung.ortsname}}</td>
      </ng-container>
      <ng-container matColumnDef="stationsname">
        <th mat-header-cell *matHeaderCellDef mat-sort-header data-qa="stationsname">Stationsname</th>
        <td mat-cell *matCellDef="let netzzuordnung;" data-qa="stationsname">{{netzzuordnung.stationsname}}</td>
      </ng-container>
      <ng-container matColumnDef="trafoFeldName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header data-qa="trafofeldname">Trafo-, Feldname, SS</th>
        <td mat-cell *matCellDef="let netzzuordnung;" data-qa="trafofeldname">{{netzzuordnung.trafoFeldName}}</td>
      </ng-container>
      <ng-container matColumnDef="uuid">
        <th mat-header-cell *matHeaderCellDef mat-sort-header data-qa="uuid">UUID</th>
        <td mat-cell *matCellDef="let netzzuordnung;" data-qa="uuid">{{netzzuordnung.uuid}}</td>
      </ng-container>
      <ng-container matColumnDef="uuidDatum">
        <th mat-header-cell *matHeaderCellDef mat-sort-header data-qa="uuidDatum">UUID-Datum</th>
        <td mat-cell *matCellDef="let netzzuordnung;" data-qa="uuidDatum">{{netzzuordnung.uuidDatum | date: 'dd.MM.yyyy'}}</td>
      </ng-container>
      <ng-container matColumnDef="technischerPlatz">
        <th mat-header-cell *matHeaderCellDef mat-sort-header data-qa="technischerplatz">Technischer Platz</th>
        <td mat-cell *matCellDef="let netzzuordnung;" data-qa="technischerplatz">{{netzzuordnung.netzzuordnungId}}</td>
      </ng-container>
      <ng-container matColumnDef="trafoFeldNummer">
        <th mat-header-cell *matHeaderCellDef mat-sort-header data-qa="trafofeldnummer">Feldnummer/S4 Name</th>
        <td mat-cell *matCellDef="let netzzuordnung;" data-qa="trafofeldnummer">{{netzzuordnung.trafoFeldNummer}}</td>
      </ng-container>
    </table>
  </div>
}
